import {IData, IContactDetailFormModel} from "../types/contact-detail.types";
import {Contact} from "../../../../../domains/models/employee";
import server from "../../../../../server";


export function viewMapper(data: IData): IContactDetailFormModel {
    const {contact} = data;

    return {
        personal: {
            mobileNumber: {
                countryCode:contact.mobileNumber.countryCode??'+91',
                number:contact.mobileNumber.number
            },
            alternateMobileNumber: {
                countryCode:contact.alternateMobileNumber?.countryCode??'+91',
                number:contact.alternateMobileNumber?.number??''
            },
            alternateEmailId: contact.alternateEmailId,
        },
        address: {
            present: {
                line1: contact.presentAddress?.line1,
                line2: contact.presentAddress?.line2,
                country: contact.presentAddress?.country,
                state: contact.presentAddress?.state,
                city: contact.presentAddress?.city,
                zipCode: contact.presentAddress?.zipCode,
            },
            permanent: {
                line1: contact.permanentAddress?.line1,
                line2: contact.permanentAddress?.line2,
                country: contact.permanentAddress?.country,
                state: contact.permanentAddress?.state,
                city: contact.permanentAddress?.city,
                zipCode: contact.permanentAddress?.zipCode,
            }
        },
        social: {
            linkedInProfileLink: contact.socialLinks?.linkedInProfileLink,
            gitHubLink: contact.socialLinks?.gitHubLink,
            others: contact.socialLinks?.others,
        }
    };
}

export function modelMapper(data: IContactDetailFormModel): Contact {
    return {
        mobileNumber: {
            countryCode: data.personal.mobileNumber.countryCode,
            number: data.personal.mobileNumber.number
        },
        alternateMobileNumber:
            {
                countryCode: data.personal.alternateMobileNumber?.countryCode??'91',
                number: data.personal.alternateMobileNumber?.number??''
            },
        alternateEmailId: data.personal.alternateEmailId,
        presentAddress: {
            line1: data.address.present.line1,
            line2: data.address.present.line2,
            country: data.address.present.country,
            state: data.address.present.state,
            city: data.address.present.city,
            zipCode: data.address.present.zipCode,
        },
        permanentAddress: {
            line1: data.address.permanent.line1,
            line2: data.address.permanent.line2,
            country: data.address.permanent.country,
            state: data.address.permanent.state,
            city: data.address.permanent.city,
            zipCode: data.address.permanent.zipCode,
        },
        socialLinks: {
            linkedInProfileLink: data.social.linkedInProfileLink,
            gitHubLink: data.social.gitHubLink,
            others: data.social.others
        }
    };
}

export async function fetchData(employeeId: string): Promise<IData> {
    const contact: Contact = await server.employee.contact.get(employeeId);

    return {contact}
}
